// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__2VTk1","noInteraction":"EventWrapper_noInteraction__hlveA"};